// extracted by mini-css-extract-plugin
export default {"protectionWrapper":"ImageProtection_protectionWrapper__n-kTs","overlay":"ImageProtection_overlay__0oTC3"};